import React from "react";
import './TeamScoreSummaryCard.scss';
import { formatNumberWithCommas } from "../../../../utill.func";

const TeamScoreSummaryCard = ({
    teamName,
    primaryTitle,
    primaryValue,
    primaryTarget,
    primarySubtitle,
    secondaryTitle,
    secondaryValue,
    secondaryTarget,
    secondarySubtitle,
}) => {
    return (
        <div className="team-score-summary-wrapper">
            {teamName && (
                <div className="team-name-section">
                    <span className="team-name-label">ทีม:</span>
                    <span className="team-name-value">{teamName}</span>
                </div>
            )}
            <div className="team-score-summary-card">
                <div className="score-summary-item">
                    <div className="score-summary-title">{primaryTitle}</div>
                    <div className="score-summary-value">
                        {formatNumberWithCommas(primaryValue)}
                        <span className="score-summary-target">/{formatNumberWithCommas(primaryTarget)}</span>
                    </div>
                    <div className="score-summary-subtitle">{primarySubtitle}</div>
                </div>

                <div className="score-summary-divider" />

                <div className="score-summary-item">
                    <div className="score-summary-title">{secondaryTitle}</div>
                    <div className="score-summary-value">
                        {secondaryValue}
                        <span className="score-summary-target">/{secondaryTarget}</span>
                    </div>
                    <div className="score-summary-subtitle">{secondarySubtitle}</div>
                </div>
            </div>
        </div>
    )
}

export default TeamScoreSummaryCard;